import { useContext } from 'react';

import { ReviewsContext } from './reviews-context';

export const useReviewsContext = () => useContext(ReviewsContext);
